
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"48","height":"30","fill":"#231F20","rx":"2"}}),_c('path',{attrs:{"fill":"#FF5F00","d":"M28.528 7.139h-8.75V22.86h8.75V7.14Z"}}),_c('path',{attrs:{"fill":"#EB001B","d":"M20.333 15c0-3.056 1.417-5.972 3.806-7.861C19.805 3.722 13.5 4.472 10.083 8.833c-3.389 4.334-2.639 10.611 1.723 14.028a9.974 9.974 0 0 0 12.36 0A10 10 0 0 1 20.334 15Z"}}),_c('path',{attrs:{"fill":"#F79E1B","d":"M40.333 15c0 5.528-4.472 10-10 10-2.25 0-4.416-.75-6.166-2.139 4.333-3.417 5.083-9.694 1.666-14.055-.5-.612-1.055-1.195-1.666-1.667C28.5 3.722 34.806 4.472 38.194 8.833A9.9 9.9 0 0 1 40.334 15Z"}})])
          )
        }
      }
    